import api from './index'

/**
 * 获取猜你想问列表
 * @param {*} data
 * @returns
 */
export const getGuessList = (data) => {
  return api({ url: '/admin/guess/lst', data })
}

/**
 * 删除猜你想问
 * @param {*} data
 * @returns
 */
export const deleteGuess = (data) => {
  return api({ url: '/admin/guess/del', method: 'post', data })
}

/**
 * 增加猜你想问
 * @param {*} data
 * @returns
 */
export const addGuess = (data) => {
  return api({ url: '/admin/guess/save', method: 'post', data })
}

/**
 * 获取兜底列表
 * @param {*} data
 * @returns
 */
export const getOutManagerList = (data) => {
  return api({ url: '/admin/btm/lst', data })
}

/**
 * 获取场景列表
 * @returns
 */
export const getSceneList = () => {
  return api({ url: '/admin/btm/scene' })
}

/**
 * 增加兜底
 * @param {}} data
 * @returns
 */
export const addOutManager = (data) => {
  return api({ url: '/admin/btm/edit', method: 'post', data })
}
/**
 * 删除兜底
 * @param {*} data
 * @returns
 */
export const deleteOutManager = (data) => {
  return api({ url: '/admin/btm/del', method: 'post', data })
}

/**
 * 获取回复列表
 * @param {*} data
 * @returns
 */
// export const getReplyList = (data) => {
//   return api({ url: '/admin/common_answer/lst', data })
// }

/**
 * 删除回复
 * @param {*} data
 * @returns
 */
export const deleteReply = (data) => {
  return api({ url: '/admin/common_answer/del', method: 'post', data })
}

/**
 * 增加回复
 * @param {*} data
 * @returns
 */
export const addReply = (data) => {
  return api({ url: '/admin/common_answer/save', method: 'post', data })
}

/**
 * 获取场景详情
 * @param {*} type
 * @returns
 */
export const getSceneDetail = (type) => {
  return api({ url: `/admin/scene/details/${type}` })
}

/**
 * 保存场景详情
 * @param {*} data
 * @returns
 */
export const saveSceneDetail = (data) => {
  return api({ url: '/admin/scene/save', method: 'post', data })
}

/**
 * 获取账号设置
 * @returns
 */
export const getAccountDetail = () => {
  return api({ url: '/admin/config/details' })
}

/**
 * 保存账户设置
 * @param {*} data
 * @returns
 */
export const saveAccountDetail = (data) => {
  return api({ url: '/admin/config/save', method: 'post', data })
}

/**
 * 获取按键导航
 * @returns
 */
export const getKeyboard = () => {
  return api({ url: '/admin/keyboardnav/read' })
}
/**
 * 设置按键导航
 * @param {*} data
 * @returns
 */
export const setKeyboard = (data) => {
  return api({ url: '/admin/keyboardnav/edit', method: 'post', data })
}

/**
 * 获取按键导航
 * @returns
 */
export const getKeyboardNav = () => {
  return api({ url: '/admin/slot/keyboarnav/list' })
}

/**
 * 删除按键导航
 * @returns
 */
export const deleteKeyboardNav = (data) => {
  return api({ url: '/admin/keyboardnav/delete', method: 'post', data })
}

/**
 * 获取网站接入
 * @returns
 */
export const getWebsite = () => {
  return api({ url: '/admin/website/detail' })
}

/**
 * 保存网站接入配置
 * @param {*} data
 * @returns
 */
export const saveWebsite = (data) => {
  return api({ url: '/admin/website/save', method: 'post', data })
}

/**
 * 获取问题分组列表
 * @param {*} data
 * @returns
 */
export const getGroupList = (data) => {
  return api({ url: '/admin/group/groupList', data })
}

/**
 * 添加或修改分组
 * @param {*} type
 * @param {*} data
 * @returns
 */
export const addGroup = (type, data) => {
  return api({ url: `admin/group/${type}`, method: 'post', data })
}

/**
 * 删除分组
 * @param {*} data
 * @returns
 */
export const deleteGroup = (data) => {
  return api({ url: '/admin/group/delete', data })
}

/**
 * 获取分组下的问题
 * @param {*} data
 * @returns
 */
export const getReplyList = (data) => {
  return api({ url: '/admin/group/answerList', data })
}

/**
 * 保存机器人配置
 * @param {*} data
 * @returns
 */
export const savePcConfig = (data) => {
  return api({ url: '/admin/config/pcSave', method: 'post', data })
}

/**
 * 获取机器人配置
 * @returns
 */
export const getPcConfig = () => {
  return api({ url: '/admin/config/pcDetail' })
}

/**
 * 获取规则
 * @returns 
 */
export const getRules = () => {
  return api({ url: '/admin/config/details' })
}

/**
 * 根据关键词获取槽值
 * @param {*} keyword 
 * @returns 
 */
export const getSlot = (keyword) => {
  return api({ url: '/admin/reception/search', data: { keyword } })
}

/**
 * 保存规则
 * @param {*} data 
 * @returns 
 */
export const saveRules = (data) => {
  return api({ url: '/admin/reception/rules', method: 'post', data })
}

/**
 * 获取规则列表
 * @param {*} data 
 * @returns 
 */
export const getRuleList = (data) => {
  return api({ url: '/admin/reception/rulesList', method: 'post', data })
}

/**
 * 新增或编辑规则
 * @param {*} type 
 * @param {*} data 
 * @returns 
 */
export const addRule = (type, data) => {
  return api({ url: `/admin/reception/${type}`, method: 'post', data })
}

/**
 * 删除规则
 * @param {*} id 
 * @returns 
 */
export const deleteRule = (id) => {
  return api({ url: '/admin/reception/delRules', data: { id } })
}